import {
  tripLocationRealtimeMessageSchema,
  type TripLocationRealtimeMessage,
} from "@ehes/contracts";
import { getAuthToken } from "./api";

export const TRIP_LOCATION_SOCKET_PROTOCOL = "ehes-location-v1";
export type TripLocationAudience = "admin" | "company";

function tripLocationSocketUrl(
  tripId: string,
  audience: TripLocationAudience,
) {
  const scope = audience === "company" ? "organizations" : "admin";
  const url = new URL(
    `/api/${scope}/trips/${encodeURIComponent(tripId)}/live`,
    window.location.origin,
  );
  url.protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}

export function createTripLocationSocket(
  tripId: string,
  audience: TripLocationAudience = "admin",
) {
  const token = getAuthToken();
  if (!token) throw new Error("Canlı konum bağlantısı için oturum bulunamadı.");

  return new WebSocket(tripLocationSocketUrl(tripId, audience), [
    TRIP_LOCATION_SOCKET_PROTOCOL,
    token,
  ]);
}

export function parseTripLocationSocketMessage(
  data: unknown,
): TripLocationRealtimeMessage | null {
  if (typeof data !== "string") return null;

  try {
    const payload: unknown = JSON.parse(data);
    const result = tripLocationRealtimeMessageSchema.safeParse(payload);
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}
